import TwitterIcon from "../../../public/assets/icon_twitter.svg";

export default TwitterIcon;
